import { render } from "./HeroPrincipal.vue?vue&type=template&id=7a77706c&scoped=true&ts=true"
import script from "./HeroPrincipal.vue?vue&type=script&lang=ts"
export * from "./HeroPrincipal.vue?vue&type=script&lang=ts"

import "./HeroPrincipal.vue?vue&type=style&index=0&id=7a77706c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a77706c"]])

export default __exports__